import BACKGROUND from 'images/b-day/bg.svg';
import RIBBON from 'images/b-day/ribbon.svg';

export default {
    BACKGROUND,
    RIBBON
};
